/** @format */

import React, { PureComponent, ReactNode } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { FilterListReducerFieldName, FilterListReducers } from '../../modules/filter/FilterListReducers';
import moment from 'moment';
import { FilterListItemsWrapper } from './FilterListItemsWrapper';
import i18n from '../../core/i18n';

interface FilterListProps {
    classes: any;
    dispatch: any;

    columnName?: string;
    headerFilterListElementName?: string;
    headerFilterListElementHasValue?: boolean;
    headerFilterListElementValue?: any;
    elementList?: Array<object>;
    clearAll?: boolean;
    showRender?: boolean;
    showInactiveFilters?: boolean;
    renderChangeTime?: moment.Moment;
}

interface FilterListState {
    filters: Array<{ elementName: string; columnName: string; value: any; rawValue: any; elementHasValue: boolean; overwriteValueDisplay?: string }>;
    activeFilters: Array<{ elementName: string; columnName: string; value: any; rawValue: any; elementHasValue: boolean }>;
    renderChangeTime: moment.Moment;
    showRender?: boolean;
}

const _ = require('underscore');

class FilterList extends PureComponent<FilterListProps, FilterListState> {
    constructor(props: FilterListProps, context: FilterListState) {
        super(props, context);

        this.state = {
            showRender: false,
            filters: [],
            activeFilters: [],
            renderChangeTime: moment(),
        };
    }

    componentDidUpdate(prevProps: Readonly<FilterListProps>, prevState: Readonly<FilterListState>, snapshot?: any): void {
        const {showRender} = this.state;
        const {clearAll} = prevProps;
        if (!prevProps.clearAll && this.props.clearAll) {
            console.log("bbbb");
            this.setState({
                showRender: false,
                filters: [],
                activeFilters: [],
                renderChangeTime: moment(),
            });
        }
    }

    static getDerivedStateFromProps(props: any, state: FilterListState): FilterListState {
        if (props.filterItemManage && !props.filterItemManage.shouldRemove) {
            const key = props.filterItemManage.key;
            const value = props.filterItemManage.value;
            const rawValue = props.filterItemManage.rawValue;

            if (state.activeFilters && Array.isArray(state.activeFilters)) {
                const newFilter: Array<{ elementName: string; columnName: string; value: any; rawValue: any; elementHasValue: boolean }> = [];
                state.activeFilters.map((el) => {
                    if (el.elementName !== key) {
                        if (Array.isArray(el.value)) {
                            if (!el.value.includes(value)) {
                                newFilter.push(el);
                            }
                        } else {
                            if (el.value !== value) {
                                newFilter.push(el);
                            }
                        }
                    } else {
                        if (Array.isArray(el.value)) {
                            const newVal: any = [];
                            el.value.map((el2, indx) => {
                                if (el2 !== value) {
                                    newVal.push(el2);
                                }
                            });

                            el.value = newVal;
                            el.rawValue = rawValue;
                            newFilter.push(el);
                        }
                    }
                });
                state.activeFilters = newFilter;
                state.filters = newFilter;
            }
        }

        if (props.clearAll !== true && props.headerFilterListElementName && !props.filterItemManage) {
            let value = props.headerFilterListElementValue;
            let rawValue = props.headerFilterListElementRawValue;

            if (props.elementList) {
                if (Array.isArray(props.headerFilterListElementValue)) {
                    const tmpValues: any = [];
                    _.each(props.headerFilterListElementValue, (item: any) => {
                        const realValue = _.find(props.elementList, (realItem: any) => {
                            if (item === realItem.value) {
                                return realItem;
                            }
                        });
                        tmpValues.push(realValue.name);
                    });
                    value = tmpValues;
                }
            }

            const filter = _.find(
                state.filters,
                (item: { elementName: string; columnName: string; value: any; rawValue: any; elementHasValue: boolean }) => {
                    if (item.elementName === props.headerFilterListElementName) {
                        return item;
                    }
                }
            );
            if (filter) {
                filter.value = value;
                if (value === 'null') {
                    filter.overwriteValueDisplay = i18n.t('general:common.empty_filter');
                }
                filter.elementHasValue = props.headerFilterListElementHasValue;
            } else {
                state.filters.push({
                    columnName: props.columnName,
                    elementName: props.headerFilterListElementName,
                    elementHasValue: props.headerFilterListElementHasValue,
                    overwriteValueDisplay: value === 'null' ? i18n.t('general:common.empty_filter') : undefined,
                    value: value,
                    rawValue: rawValue,
                });
            }
        }

        if (props.showRender === true && props.renderChangeTime !== state.renderChangeTime && !props.filterItemManage) {
            //This handles object reference in case someone modifies the object
            state.activeFilters = [];
            _.each(state.filters, (item: { elementName: string; columnName: string; value: any; rawValue: any; elementHasValue: boolean }) => {
                if (item.elementHasValue) {
                    state.activeFilters.push({ ...item });
                }
            });
            if (state.activeFilters.length > 0) {
                state.showRender = true;
            }
        }

        return state;
    }

    render(): ReactNode {
        const { filters, activeFilters, showRender } = this.state;
        const { showInactiveFilters = false } = this.props;

        const output = [];
        if (filters.length > 0 && showInactiveFilters) {
            output.push(<FilterListItemsWrapper key={'selected_filters_list'} filters={filters} header={'general:common.selected_filters'} />);
        }
        if (activeFilters.length > 0 && showRender) {
            output.push(<FilterListItemsWrapper key={'active_filters_list'} filters={activeFilters} header={'general:common.active_filters'} />);
        }

        return <div>{output}</div>;
    }
}

const stateToProps = (state: { filterReducer: FilterReducers; filterListReducer: FilterListReducers }): object => {
    const { filterReducer, filterListReducer } = state;
    if (
        filterReducer &&
        filterReducer.type === FilterReducerFieldName.HEADER_FILTER_MANAGE_ELEMENT &&
        filterReducer.filterItemManage &&
        !filterReducer.filterItemManage.shouldRemove
    ) {
        return {
            ...filterReducer,
            ...filterListReducer,
            filterItemManage: filterReducer.filterItemManage,
        };
    }

    if (filterReducer && filterReducer.type === FilterReducerFieldName.HEADER_FILTER_MANAGE && typeof filterReducer.clearAll !== 'undefined') {
        return {
            clearAll: true,
            showRender: false,
        };
    }
    if (
        filterListReducer &&
        filterListReducer.type === FilterListReducerFieldName.HEADER_FILTER_MANAGE &&
        filterListReducer.headerFilterListElementName
    ) {
        let value = filterListReducer.headerFilterListElementValue;
        if (Array.isArray(filterListReducer.headerFilterListElementValue)) {
            value = [...value];
        }
        return {
            clearAll: false,
            columnName: filterListReducer.columnName,
            elementList: filterListReducer.elementList,
            headerFilterListElementName: filterListReducer.headerFilterListElementName,
            headerFilterListElementHasValue: filterListReducer.headerFilterListElementHasValue,
            headerFilterListElementValue: value,
            headerFilterListElementRawValue: filterListReducer.headerFilterListElementRawValue,
        };
    }
    if (
        filterListReducer &&
        filterListReducer.type === FilterListReducerFieldName.HEADER_FILTER_MANAGE &&
        typeof filterListReducer.showRender !== 'undefined'
    ) {
        return {
            showRender: filterListReducer.showRender,
            renderChangeTime: moment(),
        };
    }
    return {
        clearAll: false,
    };
};

export default compose<any, any>(connect(stateToProps), withStyles(adescomStyle))(FilterList);
